import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages } from "../../Utils/LocalImages";
import { handleApiErrors, htmlToText } from "../../Utils/Utils";
import ApiService from "../../Services/ApiService";

const DeleteUser = () => {
    const [cardsData, setCardsData] = useState();

    const getAboutUsPageContent = async () => {
        try {
            const response = await ApiService.getAboutUsPageContent();
            setCardsData(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    }

    useEffect(() => { getAboutUsPageContent() }, []);
    const decodeHtml = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.documentElement.textContent;
    };

    return (
        <div className="d-flex flex-column mb-auto">
            <PageTitleBanner PageTitle={"Delete Account"} breadCrumpPageTitle={"Delete Account"} />
            <div className="about-us-page-container d-flex flex-column align-items-center m-0">
                <div className="container-fluid ps-4">
                    <h2 className="Heading headingColor text-center mt-4 mb-5 fw-600">
                        Important Notes
                    </h2>
                    <div className="mb-4">
                        <div className="headingColor mb-2 medium-text fw-600">1.&nbsp;Data Loss</div>
                        <p className="medium-text fw-400">Deleting your account is irreversible. All your data, including profile information, posts, and messages, will be permanently removed.</p>
                    </div>
                    <div className="mb-4">
                        <div className="headingColor mb-2 medium-text fw-600">2.&nbsp;Subscriptions</div>
                        <p className="medium-text fw-400">Ensure you cancel any active subscriptions linked to your account to prevent future charges.</p>
                    </div>
                    <div className="mb-4">
                        <div className="headingColor mb-2 medium-text fw-600">3.&nbsp;Download Data</div>
                        <p className="medium-text fw-400">If you wish to keep a copy of your data, please download it before deleting your account.</p>
                    </div>
                    <div className="mb-4">
                        <div className="headingColor mb-2 medium-text fw-600">4.&nbsp;Customer Support</div>
                        <p className="medium-text fw-400">If you encounter any issues during the process, please contact our support team at <a href="support@learnandachieve.in." className="headingColor">support@learnandachieve.in</a>.</p>
                    </div>

                </div>
            </div>
        </div >
    );
};
export default DeleteUser;
